import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/warehouse')({ component: WarehouseLayout });

/**
 * Nessun chrome di rotta: ogni pagina del magazzino porta la sua testata MaeDesign e la barra
 * `WarehouseNav`. Un header di layout in più significherebbe due titoli sopra la stessa pagina.
 */
function WarehouseLayout() {
  return <Outlet />;
}
